import { User, Mail, Phone, FileText } from "lucide-react";
import { Contact } from "./types";
import { useTranslation } from "react-i18next";

interface ContactInfoProps {
  contact: Contact;
}

export const ContactInfo = ({ contact }: ContactInfoProps) => {
  const { t } = useTranslation();
  const fullName = `${contact.first_name} ${contact.last_name || ''}`.trim();
  
  return (
    <div className="space-y-6">
      <div className="flex items-start space-x-4">
        <div className="p-2 bg-gray-100 rounded-sm">
          <User className="h-8 w-8 text-gray-600" />
        </div>
        
        <div>
          <h3 className="text-xl font-medium">{fullName}</h3>
          {contact.function && (
            <p className="text-gray-600">{contact.function}</p>
          )}
        </div>
      </div>
      
      <div className="space-y-4">
        {contact.email && (
          <div className="flex items-center">
            <Mail className="h-5 w-5 text-gray-400 mr-3" />
            <a 
              href={`mailto:${contact.email}`} 
              className="text-digger-blue hover:underline"
            >
              {contact.email}
            </a>
          </div>
        )}
        
        {contact.phone && (
          <div className="flex items-center">
            <Phone className="h-5 w-5 text-gray-400 mr-3" />
            <a 
              href={`tel:${contact.phone}`} 
              className="text-digger-blue hover:underline"
            >
              {contact.phone}
            </a>
          </div>
        )}
        
        {contact.notes && (
          <div>
            <div className="flex items-center mb-2">
              <FileText className="h-5 w-5 text-gray-400 mr-3" />
              <span className="font-medium">{t('companies.info.notes')}</span>
            </div>
            <p className="pl-8 text-gray-700">{contact.notes}</p>
          </div>
        )}
      </div>
    </div>
  );
};
